// extracted by mini-css-extract-plugin
module.exports = {"status-badge":"reference-object_status-badge__w_ibj","eyebrow":"reference-object_eyebrow__Kkj6I","breadcrumbs":"reference-object_breadcrumbs__19f5a"};